module.exports = __webpack_public_path__ + "img/img_service_03.3a6db339.png";